/**
 * Component for delaying the display of it's children
 *
 * @param children - children of the component
 * @param delay - delay's duration
 */

import { useEffect, useState } from 'react';

type DisplayDelayProps = {
  children: React.ReactNode;
  delay: number;
};

export const DisplayDelay = ({ children, delay = 2000 }: DisplayDelayProps) => {
  const [showChildren, setShowChildren] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowChildren(true);
    }, delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [delay]);

  if (!showChildren) return null;

  return children;
};
